module.exports = __webpack_public_path__ + "img/m-nex32-back.ab7fcf07.jpg";